/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Citations_LabelInputs */

const en_why_listening_citations_label = /** @type {(inputs: Why_Listening_Citations_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Citation skipping`)
};

const es_why_listening_citations_label = /** @type {(inputs: Why_Listening_Citations_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omisión de citas`)
};

/**
* | output |
* | --- |
* | "Citation skipping" |
*
* @param {Why_Listening_Citations_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_citations_label = /** @type {((inputs?: Why_Listening_Citations_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Citations_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_citations_label(inputs)
	return en_why_listening_citations_label(inputs)
});